// extracted by mini-css-extract-plugin
export default {"title":"MessagCard_title__bH8DM","subtitle":"MessagCard_subtitle__I9BSZ","normalTitle":"MessagCard_normalTitle__+oLBT"};